import { render, staticRenderFns } from "./Corrigendum.vue?vue&type=template&id=3cef45fa"
import script from "./Corrigendum.vue?vue&type=script&lang=js"
export * from "./Corrigendum.vue?vue&type=script&lang=js"
import style0 from "./Corrigendum.vue?vue&type=style&index=0&id=3cef45fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports